import Nullstack from 'nullstack';
export default function IconShoppingCartPlus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-shopping-cart-plus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M17 17h-11v-14h-2"
  }), "   ", Nullstack.element("path", {
    d: "M6 5l6.005 .429m7.138 6.573l-.143 .998h-13"
  }), "   ", Nullstack.element("path", {
    d: "M15 6h6m-3 -3v6"
  }), " ");
}